import { Form, Segmented, Select } from "antd"
import dayjs, { Dayjs } from "dayjs"

import { CustomRangePicker } from "@/components/_Shared/CustomRangePicker"

import classes from "./AnalyticsSettings.module.scss"

import { IPagingResponse } from "@/types/api"
import { IDepot } from "@/types/IDepot"
import { IFuelType } from "@/types/IFuelType"
import { DeliveryType } from "@/types/IOrder"
import { Period } from "@/types/IOrderReport"
import { ISelectListItem } from "@/types/ui"


export interface AnalyticsSettingsProps {
  fuelTypes: IPagingResponse<IFuelType> | undefined
  depots: IDepot[] | undefined
  customerClients: ISelectListItem[] | undefined
  customerCategories: ISelectListItem[] | undefined
  options: AnalyticsSettingsOptions
  onRangeChange: ((dates: [start: Dayjs | null, end: Dayjs | null] | null, dateStrings: [string, string]) => void) | undefined
  onPeriodChange: ((period: Period) => void) | undefined
  onChosenFuelTypeChange: ((fuelTypeId: number | undefined) => void) | undefined
  onChosenDepotChange: ((depotId: number | undefined) => void) | undefined
  onCustomerClientChange: ((customerClientId: number | undefined) => void) | undefined
  onCustomerCategoryChange: ((categoryId: number | undefined) => void) | undefined
  isComparison: boolean
  hideCustomer?: boolean
}

export interface AnalyticsSettingsOptions {
  depotId: number | undefined
  fuelTypeId: number | undefined
  startDate: string | undefined
  endDate: string | undefined
  activePeriod: Period | undefined
  customerClientId: number | undefined
  customerCategoryId: number | undefined
  deliveryType: DeliveryType
}

const periods = [
  {
    label: "Год",
    value: Period.Year
  },
  {
    label: "Квартал",
    value: Period.Quarter
  },
  {
    label: "Месяц",
    value: Period.Month
  },
  {
    label: "Неделя",
    value: Period.Week
  },
  {
    label: "День",
    value: Period.Day
  }
]

const AnalyticsSettings = (props: AnalyticsSettingsProps) => {
  const {
    fuelTypes,
    depots,
    customerClients,
    customerCategories,
    options,
    onRangeChange,
    onPeriodChange,
    onChosenFuelTypeChange,
    onChosenDepotChange,
    onCustomerClientChange,
    onCustomerCategoryChange,
    hideCustomer
  } = props

  const {
    startDate,
    endDate,
    activePeriod
  } = options

  return (
    <Form layout="vertical" size="large">
      <Form.Item>
        <CustomRangePicker
          value={[startDate ? dayjs(startDate) : undefined, endDate ? dayjs(endDate) : undefined]}
          onChange={onRangeChange}
        />
      </Form.Item>
      <Form.Item>
        <Segmented
          options={periods}
          value={activePeriod}
          onChange={onPeriodChange}
        />
      </Form.Item>
      <Form.Item
        className={classes["mb-8"]}
        label="Вид топлива">
        <Select
          onClear={() => onChosenFuelTypeChange && onChosenFuelTypeChange(undefined)}
          onChange={onChosenFuelTypeChange}
          value={options.fuelTypeId}
          placeholder="Вид топлива"
          showSearch
          allowClear
          options={fuelTypes?.response.data.map(d => ({
            value: d.id,
            label: d.name
          }))}
        />
      </Form.Item>
      <Form.Item
        className={classes["mb-10"]}
        label="Нефтебаза">
        <Select
          onClear={() => onChosenDepotChange && onChosenDepotChange(undefined)}
          onChange={onChosenDepotChange}
          value={options.depotId}
          placeholder="Нефтебаза"
          showSearch
          allowClear
          options={depots?.map(d => ({
            value: d.id,
            label: d.name
          }))}
        />
      </Form.Item>
      <Form.Item
        label="Клиент">
        <Select
          onClear={() => onCustomerClientChange && onCustomerClientChange(undefined)}
          onChange={onCustomerClientChange}
          value={options.customerClientId}
          placeholder="Клиент"
          showSearch
          allowClear
          options={customerClients}
        />
      </Form.Item>
      <Form.Item
        label="Категория клиентов">
        <Select
          onClear={() => onCustomerCategoryChange && onCustomerCategoryChange(undefined)}
          onChange={onCustomerCategoryChange}
          value={options.customerCategoryId}
          placeholder="Категория клиентов"
          showSearch
          allowClear
          options={customerCategories}
        />
      </Form.Item>
    </Form>
  )
}

export default AnalyticsSettings